import React from 'react';

import WalletBetrBucksIcon from '@/assets/icons/wallet-betr-bucks';
import WalletCashIcon from '@/assets/icons/wallet-cash';
import WalletGoldIcon from '@/assets/icons/wallet-gold';
import { Text, TextProps } from '@/components/TextComponent';
import { Row, RowProps } from '@/components/lib/components';
import { SocialCurrency } from '@/hooks/use-social-currency';

import { TransactionDisplayCurrency } from '../utils/formatters';

const CURRENCY_ICONS: Record<TransactionDisplayCurrency, React.FC<{ size?: number }>> = {
    [SocialCurrency.CASH]: WalletCashIcon,
    [SocialCurrency.COINS]: WalletGoldIcon,
    BONUS: WalletBetrBucksIcon,
};

type CurrencyAmountProps = {
    /** Display currency icon (gold coin / green cash / purple bonus). `null` = real-money, no icon. */
    currency: TransactionDisplayCurrency | null;
    /** Pre-formatted amount text, e.g. `+1.00`, `-5.00`, `+10,000`. */
    amount: string;
    iconSize?: number;
    gap?: RowProps['gap'];
} & Omit<TextProps, 'children'>;

export const CurrencyAmount = ({
    currency,
    amount,
    iconSize = 16,
    gap = 's4',
    variant = 'bodyMedium',
    ...textProps
}: CurrencyAmountProps) => {
    const CurrencyIcon = currency ? CURRENCY_ICONS[currency] : null;

    return (
        <Row alignItems="center" gap={gap}>
            {CurrencyIcon ? <CurrencyIcon size={iconSize} /> : null}
            <Text variant={variant} {...textProps}>
                {amount}
            </Text>
        </Row>
    );
};
